/**
 * «Возможен соседний знак» у Луны.
 *
 * Когда времени рождения нет, карта считается на полдень. Планеты за сутки
 * знак почти не меняют — кроме Луны: она проходит знак примерно за 2,5 дня,
 * то есть примерно каждые третьи сутки успевает перейти в следующий. В такие
 * сутки полуденный знак Луны — догадка, и молчать об этом нельзя: знак Луны
 * человек запоминает и уносит с собой.
 *
 * Знал ли этот день переход, решает СЕРВЕР (сравнивает знак на 00:00 и 23:59
 * по месту рождения) и вешает признак sign_may_shift прямо на Луну. Поэтому
 * пометку рисует тот, кто рисует планету, и тащить флаг сквозь пропсы не надо.
 *
 * Отдельным файлом, а не внутри вкладок: её показывают и вкладка «Планеты»,
 * и подсказка Луны в колесе. Это два разных модуля, и если бы один тянул
 * другой ради одной строки, сборка потащила бы за ней весь корпус трактовок.
 */

import { BIRTH_TIME_CAPTION } from '@/lib/birthTime';

export const MOON_SIGN_SHIFT_NOTE =
  'Луна в этот день переходила из знака в знак — возможен соседний знак';

export default function MoonSignShiftNote({ className = '' }) {
  return (
    <p
      className={`mt-2 rounded-md bg-amber-50 px-2 py-1.5 text-xs leading-snug text-amber-800 ${className}`}
      data-testid="moon-sign-shift-note"
    >
      {MOON_SIGN_SHIFT_NOTE}
    </p>
  );
}

/** Подпись «Время рождения не указано, поэтому Луна, Асцендент и дома не учитываются». */
export function BirthTimeNote({ className = '' }) {
  return (
    <p
      className={`mt-2 rounded-md bg-amber-50 px-2 py-1.5 text-xs leading-snug text-amber-800 ${className}`}
      data-testid="birth-time-note"
    >
      {BIRTH_TIME_CAPTION}
    </p>
  );
}
